module.exports = __webpack_public_path__ + "img/edit-compliance-active.51d3ffd7.svg";